import React from "react";
import styled from "styled-components";
import CommonNoticeText from "../../../views/common/NoticeText/CommonNoticeText";
import Button from "../Button/Button";
import BlackLayer from "./BlackLayer";

/* 
  header
  title: String
  desc: array -> <br /> 같은 css 속성 기준으로 나눔
  ps: String
  psIcon: boolean
  button: array

  button: [
    {
      severity: String,
      disable: String,
      clickEvent: void,
      text: String
    }
  ]
*/
const Layer = ({ headerIcon, title, desc, ps, psIcon, button }) => {
  return (
    <BlackLayer>
      <Container>
        {headerIcon?.trim() && (
          <Header>
            <img
              src={headerIcon}
              style={{ minWidth: "36px", minHeight: "36px" }}
            />
          </Header>
        )}
        <Body>
          <Title>{title}</Title>
          <Description>{desc}</Description>

          {ps?.trim() && (
            <PostScript>
              <CommonNoticeText title={ps} psIcon={psIcon} text="" />
            </PostScript>
          )}
        </Body>
        <Bottom>
          {button.map((data, i) => (
            <Button
              severity={data.severity}
              disable={data.disable}
              size={data.size}
              // small={data.small}
              clickEvent={data.clickEvent}
              key={`layerBtnIdx-${i}`}>
              {data.text}
            </Button>
          ))}
        </Bottom>
      </Container>
    </BlackLayer>
  );
};

const Container = styled.div`
  /* width: 320px; */
  width: calc(100% - 80px);
  display: flex;
  padding: 24px 16px 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Title = styled.div`
  white-space: pre-wrap;
  align-self: stretch;
  color: #333;
  text-align: center;

  /* Title/2/SemiBold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.36px;
  word-break: keep-all;
`;

const Description = styled.div`
  align-self: stretch;
  color: #666;
  text-align: center;

  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
  word-break: keep-all;

  /* color: #6b65de;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.28px; */
`;

const PostScript = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-radius: 10px;
  background: #fafafa;
`;

const Bottom = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export default Layer;
